import { Link } from "react-router-dom";
import BreadCrumbComp from "../components/BreadCrumbComp";
import PageSchema from "../components/PageSchema";
import classes from "./ReturnPolicy.module.css";

export default function ReturnPolicy() {
  return (
    <>
      <PageSchema
        type="WebPage"
        title="Return Policy - Prime Cloud Systems Delivery Methods and Timelines"
        description="Explore Prime Cloud Systems Return Policy. Learn about delivery times, cut-off schedules, DHL shipping, handling of missing or damaged items, and fast UK-wide delivery for IT products."
        url="https://primecloudsystems.com/return-policy"
        breadcrumbs={[
          { name: "Home", url: "https://primecloudsystems.com/" },
          {
            name: "Return Policy",
            url: "https://primecloudsystems.com/return-policy",
          },
        ]}
      />

      <BreadCrumbComp
        currentPage="Return Policy"
        title="Return Policy | Prime Cloud Systems"
        description="Read Prime Cloud Systems’ Return Policy covering eligibility, conditions, and timelines for IT hardware, networking equipment, and related services to ensure a smooth and transparent return process."
      />

      <div className={`container ${classes.RefundReturnsPolicyContainer}`}>
        <h3 className={classes.subheading}>SHIPPING & RETURNS</h3>
        <p className={classes.paragraph}>
          New and unopened items may be returned within 30 days of delivery,
          with limited exceptions. Confirmed returns are usually processed
          within four weeks of primecloudsystems.com receipt of the returned
          item (to cover transit and processing time).
        </p>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>primecloudsystems</b>
          </Link>{" "}
          can ship to virtually any address in the world. Due to U.S. Export
          laws, however, certain restrictions may apply. Certain products may
          also be ineligible for international shipping.
        </p>
        <h3 className={classes.subheading}> Shipping Methods</h3>
        <h3 className={classes.subheading}> USA & Canada</h3>
        <p className={classes.paragraph}>
          We usually ship via FedEx and UPS, however we do use various freight
          carriers for larger/heavier orders. Other options such as DHL and USPS
          are available by request.
        </p>
        <h3 className={classes.subheading}>International</h3>
        <p className={classes.paragraph}>
          For orders sent worldwide, we use Fedex, UPS and various freight
          carriers when needed for larger/heavier orders.
        </p>
        <h3 className={classes.subheading}>
          Customer Provided Shipping Account
        </h3>
        <p className={classes.paragraph}>
          You can send your own shipping account information to us during the
          order checkout process. Select the “Use My Own Shipping Account”
          option and fill out the short form that appears.
        </p>
        <h3 className={classes.subheading}>Blind Shipping</h3>
        <p className={classes.paragraph}>
          We offer blind shipping as an option for orders. Please contact{" "}
          <Link to={"mailto:sales@primecloudsystems.com"}>
            <b>sales@primecloudsystems.com</b>
          </Link>{" "}
          with your order number to request blind shipping.
        </p>
        <b>
          {" "}
          <i>
            Note: we must be notified prior to shipment pickup by your selected
            shipping carrier.
          </i>
        </b>
        <h3 className={classes.subheading}>Order Processing Time</h3>
        <h3 className={classes.subheading}>Parts & Upgrades</h3>
        <p className={classes.paragraph}>
          Unless otherwise noted, orders that do not require special
          configuration received by 1 pm (CST) are usually processed and shipped
          the same day based on availability of your items and the shipping
          options you choose.
        </p>

        <h3 className={classes.subheading}>Software or e-Licenses</h3>
        <p className={classes.paragraph}>
          Certain products require additional information before processing your
          order. A representative will be in contact with you following a
          qualifying order.
        </p>

        <h3 className={classes.subheading}>Shipping Prices Explained</h3>
        <h3 className={classes.subheading}>Pricing</h3>
        <p className={classes.paragraph}>
          In pursuit of keeping our prices as low as possible we do not charge
          additional handling fees on top of standard rates provided by the
          shipping carriers. Rates are provided immediately via direct online
          connections to the carriers. The shipping price is not based on the
          cost or value of the product. Shipping prices are based on the weight
          of the product you are ordering, rounded to the next full pound, and
          the location it is traveling to. Item weight information can be found
          on the item detail page of each product.
        </p>
      </div>
    </>
  );
}
